<template>
  <Modal v-model="displayModal" title="Are you sure?" :footer="false">
    <div>
      <p>Are you sure you want to cancel this subscription?</p>
      <p>All users will have their licence removed.</p>
      <div>
        <button
          type="button"
          @click="emit('toggle-cancel-subscription-modal')"
          class="btn btn-default"
          style="margin-right: 2rem"
        >
          Cancel
        </button>
        <button type="button" @click="cancelSubscription" class="btn btn-primary">Confirm</button>
      </div>
      <p v-if="cancelError" class="text-danger">{{ cancelError }}</p>
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { Modal } from "uiv";

const props = defineProps<{
  modelValue: boolean;
  subscriptionId: string | null;
  cancelError: string | null;
}>();

const emit = defineEmits(["toggle-cancel-subscription-modal", "cancel-subscription"]);

const displayModal = computed(() => {
  return props.modelValue;
});

const cancelSubscription = () => {
  emit("cancel-subscription", props.subscriptionId);
};
</script>

<style scoped lang="less"></style>
